var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.5C4 9.84518 4.27982 10.125 4.625 10.125C4.97018 10.125 5.25 9.84518 5.25 9.5L5.25 6.125L8.625 6.125C8.97018 6.125 9.25 5.84518 9.25 5.5C9.25 5.15482 8.97018 4.875 8.625 4.875L5.25 4.875V1.5C5.25 1.15482 4.97018 0.875 4.625 0.875C4.27982 0.875 4 1.15482 4 1.5L4 4.875H0.625C0.279822 4.875 0 5.15482 0 5.5C0 5.84518 0.279822 6.125 0.625 6.125H4V9.5Z",
    fill: "#086DE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBlue);
export default __webpack_public_path__ + "static/media/add-blue.2d9e8037582d03db257da05272752659.svg";
export { ForwardRef as ReactComponent };